module.exports = __webpack_public_path__ + "img/circle-caret-down.691bf672.svg";